import { SharePointItemsViewNavigationLocationState } from '../Schema/SharePointItemsViewNavigationLocationState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const initialState = new ObservableMap<string, SharePointItemsViewNavigationLocationState>();

export const getStore = createStore('SharePointItemsViewNavigationLocationStore', initialState);
